import React, { useEffect, useState } from "react";
import Modal from "../Modal";
import { Grid, Typography, Divider } from "@mui/material";
import "./infomodal.css";
import { formatDate, formatInfoData } from "./formatInfoData";
import { capitalEachLetter } from "utils/capitalEachLetter";

const CustomeInfoModal = ({ open, setOpen, fetchData, title }) => {
  const [data, setData] = useState({});
  const handleClose = React.useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  useEffect(() => {
    if (fetchData) {
      let createdByRef = fetchData?.created_by_ref || null;
      let modifiesByRef = fetchData?.modified_by_ref || null;
      setData({
        "Created By": createdByRef ? `${createdByRef?.firstName} ${createdByRef?.lastName}` : "Admin",
        "Created Time": formatDate(fetchData?.createdAt),
        "Modified By": modifiesByRef ? `${modifiesByRef?.firstName} ${modifiesByRef?.lastName}` : "-",
        "Modified Time": formatDate(fetchData?.updatedAt),
      });
    }

    return () => {
      setData({});
    };
  }, [fetchData]);

  return (
    <Modal open={open} handleClose={handleClose} style={{ width: "400px", borderRadius: "12px", padding: "16px", background: "white" }}>
      <Grid container spacing={2} className="info-data">
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <Typography variant="h6" fontWeight="600" fontFamily="Poppins">
            {title}
          </Typography>
          <Divider sx={{ backgroundColor: "#000", height: "1px", marginTop: 1 }} />
        </Grid>

        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className="metadata-section">
          {Object.entries(data).map(([key, value], index, array) => (
            <React.Fragment>
              <Grid key={key} container justifyContent="space-between" className="metadata-row">
                <Grid item className="info-main-title">
                  {key}
                </Grid>
                <Grid item>
                  <Typography className="sub-title">{capitalEachLetter(value)}</Typography>
                </Grid>
              </Grid>
              {index < array.length - 1 && <Divider sx={{ borderColor: "#aaa", height: "0.5px", marginY: 1 }} />}
            </React.Fragment>
          ))}
        </Grid>
      </Grid>
    </Modal>
  );
};

export default CustomeInfoModal;
